import { object, string, boolean } from 'zod'
import type { BannerFullProps } from 'src/components/department/types/banner-full'

export function useBannerFull() {
  function validateProps(props: BannerFullProps) {
    try {
      const schema = object({
        enableSession: boolean(),
        BannersFull: object({
          linkURL: string(),
          Texto: string(),
          textColor: string(),
          image: object({
            mobile: string(),
            tablet: string(),
            desktop: string(),
          }),
        }),
      })

      schema.parse(props)

      return true
    } catch {
      console.warn('Invalid banner mood data')

      return false
    }
  }

  return {
    validateProps,
  }
}
